import script from "./LoadInterface.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadInterface.vue?vue&type=script&setup=true&lang=js"

import "./LoadInterface.vue?vue&type=style&index=0&id=4a8de388&lang=css"

const __exports__ = script;

export default __exports__